export enum ConfirmationResult {
  Cancel,
  Confirmed,
}
